import { GetterTree } from 'vuex'
import CategoriesState from '../types/CategoriesTypes'
import RootState from '@vue-storefront/core/types/RootState'

const getters: GetterTree<CategoriesState, RootState> = {
  categories: state => state.categories,
  categoriesLoad: state => state.categoriesLoad,
  categoriesProducts: state => state.categoriesProducts,
  getTotalSlidersAmount: state => state.categoriesProducts.length,
  getCategoriesLoaded: state => state.categories_loaded,
  getSlidersCategories (state) {
    return state.categoriesProducts.slice(0, state.categories_loaded)
  }
}

export default getters
